module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-500.991b453b.woff";